import {
  EDIT_PROMOTION, DELETE_PROMOTION, CREATE_PROMOTION, CREATE_PROMOTION_SUCCESS, UPDATE_PROMOTION_SUCCESS,
  UPDATE_PROMOTION, DELETE_PROMOTION_SUCCESS, FETCH_ALL_PROMOTION, FETCH_ALL_PROMOTION_SUCCESS,SET_PROMOTION,SET_ROLE
} from 'constants/promotions.constants'
import { startLoader } from 'actions/general.action';

export const setPromotion = (key, value) => {
  return {
    type : SET_PROMOTION,
    key: key,
    value: value
  }
}

export const setRoles = (key, value) => {
return {
  type: SET_ROLE,
  key:key,
  value:value
}
}

export const fetchPromotions = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_PROMOTION,
      payload: page
    })
    dispatch(startLoader())
  }
}

export const fetchPromotionsSuccess = (data) => {
  return {
    type: FETCH_ALL_PROMOTION_SUCCESS,
    payload: data
  };
};

export const deletePromotion = (id) => {
  return {
    type: DELETE_PROMOTION,
    payload: id
  };
};

export const editPromotion = (id) => {
  return {
    type: EDIT_PROMOTION,
    payload: id
  };
};

export const createPromotion = (payload) => {
  console.log(payload)
  return {
    type: CREATE_PROMOTION,
    payload: payload
  };
};

export const createPromotionSuccess = (payload) => {
  return {
    type: CREATE_PROMOTION_SUCCESS,
    payload: payload
  };
};

export const updatePromotionSuccess = (data) => {
  return {
    type: UPDATE_PROMOTION_SUCCESS,
    payload: data
  };
};

export const deletePromotionSuccess = (data) => {
  return {
    type: DELETE_PROMOTION_SUCCESS,
    payload: data
  };
};

export const updatePromotion = (payload) => {
  return {
    type: UPDATE_PROMOTION,
    payload: payload
  };
}; 